import { COMPONENT_TYPES } from "../core/component-types";
/* TODO remove, still used inside the builder in a weird way */
export const SEED_DATA = {
  name: "Fetch",
  tag: "Fetch",
  description:
    "Rest API Declarative Fetch component. Uses react-request internally",
  category: COMPONENT_TYPES.data,
  props: {},
};
